// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Ad26","errors":"Errors_errors__21Vb9"};